import { Field, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import type { FilterQuery, QueryOptions } from '../../repository/types'
import type { Tenant } from '../Tenant'
import type { TenantOption } from '../TenantOption'

@InputType()
export class GetTenantOptionsArgs extends ActionArgs {
  @Field(() => GraphQLJSON, { nullable: true })
  filter?: FilterQuery<Tenant>

  @Field(() => GraphQLJSON, { nullable: true })
  options?: QueryOptions<Tenant>
}

export interface IGetTenantOptions extends IAction<TenantOption[], GetTenantOptionsArgs> {}
